import React, {useEffect, useRef, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {isDescendant} from "../../utils/DomHelper"
import WindowEventHelper from "../../lib/WindowEventHelper"
import * as PostActions from "../../actions/contents/post"
import * as PageActions from "../../actions/contents/page"
import {addPrefix} from "../../utils/UriUtil"
import querystring from "query-string"
import {jsonResponseHandler} from "../../utils/FetchHelper"
import {DAUMBLOG, TISTORY} from "../../constants/Service"
import * as StatusTypes from "../../constants/contents/EntryStatusTypes"
import classnames from "classnames"
import PostHeadMoveCategoryPanel from "./post/PostHeadMoveCategoryPanel"

function StatusListItem({label, onClick}) {
  return (
    <li>
      <label className="lab_btn">
        {label}
        <input
          type="button" className="btn_g"
          value={label} onClick={onClick}
        />
      </label>
    </li>
  )
}


export default function EntryHeaderStatusChangeButton({type, items,  optionOpen, onChangeOpen}) {

  const rootElm = useRef(null)
  const dispatch = useDispatch()
  const [optionAvailable, setOptionAvailable] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [deleting, setDeleting] = useState(false)

  useEffect(() => {
    setOptionAvailable(items.filter(item => item.selected).length > 0)
  }, [items])

  useEffect(() => {
    function handleHideOption(e) {
      if (!isDescendant(rootElm.current, e.target)) {
        onChangeOpen(false)
      }
    }

    WindowEventHelper.add("click", handleHideOption)

    return () => {
      WindowEventHelper.remove("click", handleHideOption)
    }
  }, [])

  function handleUpdateSelectedItems(values) {
    if (type == 'posts') {
      dispatch(PostActions.updateSelectedItems(values))
    } else if (type == 'pages') {
      dispatch(PageActions.updateSelectedItems(values))
    }
  }

  function handleReceiveItems(items, totalCount) {
    if (type == 'posts') {
      dispatch(PostActions.receiveItems(items, totalCount))
    } else if (type == 'pages') {
      dispatch(PageActions.receiveItems(items, totalCount))
    }
  }

  function updateItems(changes) {
    let ids = items.filter(item => item.selected).map(item => item.id);
    handleUpdateSelectedItems({ processing : true});
    setProcessing(true)
    fetch(addPrefix(`/manage/${type}/visibility.json`), {
      method: "put",
      credentials: "include",
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      body: querystring.stringify(
        Object.assign({}, { ids: ids.join(",") }, changes)
      )
    })
      .then(jsonResponseHandler(dispatch))
      .then(data => {
        changes.processing = false;
        handleUpdateSelectedItems(changes);
        setProcessing(false)
        onChangeOpen(false)
      })
      .catch(r => {
        setProcessing(false)
        onChangeOpen(false)
        handleUpdateSelectedItems({ processing : false});
        console.error(r)
      })
  }

  function handleDelete(e) {
    if (!confirm('선택한 글을 삭제하시겠습니까?')) {
      return
    }

    let ids = items.filter(item => item.selected).map(item => item.id);
    handleUpdateSelectedItems({ deleting : true});
    setDeleting(true)

    fetch(addPrefix(`/manage/${type}.json`), {
      method: "delete",
      credentials: "include",
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      body: querystring.stringify({
        ids: ids.join(",")
      })
    })
      .then(jsonResponseHandler(dispatch))
      .then(data => {
        reFetchPosts();
      })
      .catch(r => {
        setDeleting(false)
        onChangeOpen(false)
        handleUpdateSelectedItems({ deleting : false});
        console.error(r);
      })
  }

  function reFetchPosts() {
    fetch(addPrefix(`/manage/${type}.json`) + location.search, {
      method: 'GET',
      credentials: 'include'
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        handleReceiveItems(data.items, data.totalCount)
        onChangeOpen(false)
        setDeleting(false)
        setProcessing(false)
      })
      .catch(e => {
        console.log(e);
        onChangeOpen(false)
        setDeleting(false)
        setProcessing(false)
      })
  }

  function handleMoveCategory(category) {
    let ids = items.filter(item => item.selected).map(item => item.id);
    handleUpdateSelectedItems({ processing : true});
    setProcessing(true)
    fetch(addPrefix(`/manage/${type}/category.json`), {
      method: "put",
      credentials: "include",
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      body: querystring.stringify({
        ids: ids.join(","),
        category: category.id
      })
    })
      .then(jsonResponseHandler(dispatch))
      .then(data => {
        handleUpdateSelectedItems({ category : category.label, processing : false, categoryVisibility : category.visibility});
        setProcessing(false)
        onChangeOpen(false)
      })
      .catch(r => {
        handleUpdateSelectedItems({ processing : false});
        setProcessing(false)
        onChangeOpen(false)
        console.error(r)
      })
  }

  function makeStatusList(service, type) {
    let list = []
    list.push({label:StatusTypes.PUBLIC_LABEL, clickHandler: () => updateItems({visibility: StatusTypes.PUBLIC})})
    if (type == 'posts' && service == DAUMBLOG) {
      list.push({label:StatusTypes.FOLLOWED_LABEL, clickHandler: () => updateItems({visibility: StatusTypes.FOLLOWED})})
    }
    list.push({label:StatusTypes.PRIVATE_LABEL, clickHandler: () => updateItems({visibility: StatusTypes.PRIVATE})})
    if (type == 'posts' && service == TISTORY) {
      list.push({label:StatusTypes.PROTECTED_LABEL, clickHandler: () => updateItems({visibility: StatusTypes.PROTECTED})})
    }
    list.push({label:'삭제', clickHandler: handleDelete})
    return list
  }

  const STATUS_LIST = makeStatusList(window.Config.service, type)

  return (
    <div ref={rootElm} className={classnames({
      "opt_blog": true,
      "opt_open": optionOpen,
      "change_on" : (processing || deleting)
    })}>
      <button type="button" className="btn_opt" disabled={!optionAvailable} onClick={e => onChangeOpen(!optionOpen)}>
        변경
        <span className="ico_blog ico_open"/>
      </button>
      <span className="txt_change">
        { processing && "변경중"}
        { deleting && "삭제중 "}
        <span className="ico_blog ico_change"/>
      </span>
      <div className="layer_opt layer_double">
        <strong className="tit_opt">상태 변경</strong>
        <ul className="list_opt">
          {STATUS_LIST.map((item, index) =>
            <StatusListItem key={index} label={item.label} onClick={item.clickHandler} />
          )}
        </ul>
        {type == 'posts' && <PostHeadMoveCategoryPanel moveCategory={handleMoveCategory}/>}
      </div>
    </div>
  )
}
